import React from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Typography,
} from "@mui/material";
import SteppersUI from "../../../../components/newStepper/NewStepper";
import toast from "react-hot-toast";
import { palette } from "../../../../theme/palette";
import { useNavigate } from "react-router-dom";
import { CheckIcon, UnCheckIcon, usa } from "../../../../assets/images";
import { useDispatch } from "react-redux";
import { getActiveStep } from "../../../../redux/test/actions";
import { getNetworkRegion } from "../../../../redux/node/actions";
import { useState } from "react";

const verticalLine = {
  background:
    "radial-gradient(50% 50% at 50% 50%, rgba(1, 62, 183, 0.31) 0%, rgba(255, 255, 255, 0) 100%)",
  height: "400px",
  width: 2,
  display: { xs: "none", sm: "none", md: "block" },
};
const buttonBox = {
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  mt: { xs: 5, md: 8 },
};
const button = {
  borderRadius: "5px",
  maxWidth: "7.2rem",
  width: "100%",
  ml: ".5rem",
};
const checkWrapper = {
  "& .css-i4bv87-MuiSvgIcon-root ": {
    background: "#fff",
  },
};

const data = [
  {
    name: "Ohio",
    country: "USA",
    chain: "AWS",
    direction: "US-east 1",
  },
  {
    name: "Ohio",
    country: "USA",
    chain: "AWS",
    direction: "US-east 2",
  },
  {
    name: "Ohio",
    country: "USA",
    chain: "AWS",
    direction: "US-east 3",
  },
  {
    name: "Ohio",
    country: "USA",
    chain: "AWS",
    direction: "US-east 4",
  },
];
const HomeRegion = ({ setScreen }) => {
  const [loading, setLoading] = useState(false);
  const navigation = useNavigate();
  const [checkedIndex, setCheckedIndex] = React.useState(0);
  const dispatch = useDispatch();
  // Adding the toaster
  const notify = () =>
    toast.success("Network is created.", {
      style: {
        padding: "14px",
        color: palette.primary.main,
        animation: "none",
        transition: "none",
      },
      iconTheme: {
        primary: palette.primary.main,
        secondary: "#FFFAEE",
      },
    });
  const handleChange = (event, index) => {
    if (event.target.checked) {
      setCheckedIndex(index);
    } else {
      setCheckedIndex(0);
    }
  };
  const handleBack = () => {
    setScreen(0);
  };

  const handleNext = () => {
    setLoading(true);
    let region = data[checkedIndex].direction;
    dispatch(getActiveStep(1));
    dispatch(getNetworkRegion(region));
    navigation("/network-details");
    notify();
    setLoading(false);
  };

  const dataBox = (i) => {
    return {
      background: checkedIndex === i ? "#fff" : "rgba(0, 0, 0, 0.03)",
      borderRadius: "5px",
      padding: "10px 10px",
      display: "flex",
      justifyContent: "space-between",
      border: checkedIndex === i ? "1px solid #013EB7" : "",
      alignItems: "center",
      mb: 1,
    };
  };
  return (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            mt: "2.5rem",
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* SteppersUI component */}
          <Box sx={{ maxWidth: "600px ", width: "100%" }}>
            <SteppersUI />
          </Box>
        </Box>
        <Typography variant="h1" mb={3} sx={{ mt: { xs: "1rem", sm: 1 } }}>
          What is a home region?
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            flexDirection: { xs: "column", sm: "column", md: "row" },
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "100%", md: "48%" } }}>
            <Typography variant="subtitle1" textAlign="left" mb={2}>
              The home region is the cloud provider and underlying region where
              information about the network (such as membership details) is
              stored. The available cloud providers are:
            </Typography>
            <ul>
              <li>
                <Typography variant="subtitle1" textAlign="left">
                  AWS
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle1" textAlign="left">
                  Microsoft Azure
                </Typography>
              </li>
            </ul>
            <Typography variant="subtitle1" textAlign="left" mt={3}>
              Additional regions may be whitelisted during the next and final
              step of creating a network
            </Typography>
          </Box>
          <Box sx={verticalLine} />
          <Box
            sx={{
              width: { xs: "100%", sm: "100%", md: "48%" },
              mt: { xs: 3, md: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: "2.9rem",
              }}
            >
              <Typography variant="h3"> Set Your Home Region</Typography>
              {/* <Typography
                variant="subtitle2"
                sx={{ fontStyle: "italic", whiteSpace: "nowrap" }}
              >
                Step 2/2
              </Typography> */}
            </Box>

            <Typography variant="subtitle2" mb={3}>
              The home region is where information about the network (such as
              membership details) is stored.
            </Typography>
            {/* Here we are selection one region from the map  */}
            {data.map((item, i) => (
              <Box sx={dataBox(i)} key={i}>
                <Typography variant="subtitle2">{item.name}</Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {item.country}
                  <img src={usa} alt="usa" style={{ marginLeft: "6px" }} />
                </Typography>
                <Typography variant="subtitle2">{item.chain}</Typography>
                <Typography variant="subtitle2">{item.direction}</Typography>
                <Checkbox
                  icon={<img src={UnCheckIcon} alt="unchecked" />}
                  checkedIcon={<img src={CheckIcon} alt="checked" />}
                  sx={checkWrapper}
                  checked={checkedIndex === i}
                  onChange={(event) => handleChange(event, i)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box>
            ))}
            <Box sx={buttonBox}>
              {/* Add Back button */}
              <Button variant="text" data-cy="back5" sx={button} onClick={handleBack}>
                Back
              </Button>
              {/* Add Next button  */}
              <Button
                onClick={handleNext}
                disabled={loading ? true : false}
                variant="contained"
                data-cy="Next5"
                sx={button}
              >
                {!loading ? "Next " : <CircularProgress size="1.7rem" />}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default HomeRegion;
